import * as React from 'react';
import type { SVGProps } from 'react';
const SvgLastPage = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={10}
    height={10}
    fill="none"
    viewBox="0 0 10 10"
    {...props}
  >
    <path
      fill="#999"
      d="M3.5 5 .25 1.75a.79.79 0 0 1-.23-.583.79.79 0 0 1 .23-.584.79.79 0 0 1 .583-.229.79.79 0 0 1 .584.23L5.25 4.416a.731.731 0 0 1 .177.27A.922.922 0 0 1 5.48 5a.922.922 0 0 1-.052.313.731.731 0 0 1-.177.27L1.417 9.417a.79.79 0 0 1-.584.229.79.79 0 0 1-.583-.23.79.79 0 0 1-.23-.583.79.79 0 0 1 .23-.583zm5.667-5c.236 0 .434.08.593.24.16.16.24.357.24.593v8.334c0 .236-.08.434-.24.593a.806.806 0 0 1-.593.24.806.806 0 0 1-.594-.24.806.806 0 0 1-.24-.593V.833c0-.236.08-.434.24-.593.16-.16.358-.24.594-.24"
    />
  </svg>
);
export default SvgLastPage;
